<template>
  <card class="card" title="Edit Role">
    <div>
      <form @submit.prevent>
        <div class="row">
          <div class="col-xl">
            <fg-input type="text" label="Role Name" placeholder="Role Name" v-model="role_copy.name"> </fg-input>
          </div>
          <div class="col-xl">
            <label>Description (max: 255)</label>
            <textarea
              rows="3"
              class="form-control border-input"
              placeholder="Role Description"
              maxlength="255"
              v-model="role_copy.description"
            >
            </textarea>
          </div>
        </div>

        <div class="text-center">
          <p-button type="success" round @click.native.prevent="updateRole"> Update Role </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import Multiselect from 'vue-multiselect';
import axiosAuth from '../../../axiosMain';

export default {
  components: {
    Multiselect,
  },
  props: {
    role: {
      type: Object,
    },
  },
  data() {
    return {
      role_copy: null,
    };
  },
  computed: {},
  beforeMount() {
    this.role_copy = this.role;
  },
  methods: {
    updateRole() {
      axiosAuth
        .patch('/roles/' + this.role.role_id, {
          name: this.role_copy.name,
          description: this.role_copy.description,
        })
        .then((response) => {
          this.role = response.data.data;
          this.scopes = this.role.scopes;
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('the_role_was_updated'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'danger',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data,
          });
        });
    },
  },
};
</script>

<style src="../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
<style></style>
